import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FooterService, FooterMenuItem, FooterData } from '../../services/footer.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
  currentYear = new Date().getFullYear();
  private langChangeSubscription: Subscription | null = null;

  constructor(private translateService: TranslateService, private footerService: FooterService) {}

  footerData: {
    logo: string;
    socialLinks: Array<{ iconUrl: string; url: string; label: string }>;
    aboutSection: { title: string; links: Array<{ text: string; url: string }> };
    otherSection: { title: string; links: Array<{ text: string; url: string; external?: boolean }> };
    disclaimer: string;
    copyright: string;
  } = {
    logo: 'assets/images/bannerlogo.png',
    socialLinks: [],
    aboutSection: { title: '', links: [] },
    otherSection: { title: '', links: [] },
    disclaimer: '',
    copyright: `© ${new Date().getFullYear()}`,
  };

  ngOnInit(): void {
    this.loadFooterData();
    this.langChangeSubscription = this.translateService.onLangChange.subscribe(() => {
      this.loadFooterData();
    });
  }

  private loadFooterData(): void {
    this.footerService.getFooterData().subscribe({
      next: (response: FooterData) => {
        // Set disclaimer from dedicated endpoint
        this.footerData.disclaimer = response.disclaimer;
        // Process footer menu items
        this.processFooterMenu(response.footerMenu);
      },
      error: (error: any) => {
        console.error('Error loading footer data:', error);
      },
    });
  }

  private processFooterMenu(data: FooterMenuItem[]): void {
    data.forEach((section, index) => {
      // Use index since section names are translated from backend
      // Index 0 = About this site, Index 1 = Other, Index 2 = Social Links
      switch (index) {
        case 0: // About this site
          this.footerData.aboutSection.title = section.name;
          if (section.children) {
            this.footerData.aboutSection.links = section.children.map((child: any) => ({
              text: child.name,
              url: child.url || '',
            }));
          }
          break;
        case 1: // Other
          this.footerData.otherSection.title = section.name;
          if (section.children) {
            this.footerData.otherSection.links = section.children.map((child: any) => ({
              text: child.name,
              url: child.url || '',
              external: child.url?.startsWith('http') || false,
            }));
          }
          break;
        case 2: // Social Links
          if (section.children) {
            this.footerData.socialLinks = section.children.map((child: any) => ({
              iconUrl: child.description || child.icon || '',
              url: child.url || '',
              label: child.name,
            }));
          }
          break;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }
}
